import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ShowyePageMenuService } from '@showye/showye-page-base';

@Injectable()
export class NbHomeGuard implements CanActivate {
  constructor(private menuService: ShowyePageMenuService, private router: Router) {}

  canActivate(): boolean {
    if (!!this.menuService.home) {
      this.router.navigate([this.menuService.home]);
      return false;
    } else {
      return true;
    }
  }
}
